import React, { useEffect, useState } from "react";
import { Customer } from "@/api/customers";
import RigthPanel, { RigthPanelType } from "@/ui-controls/RigthPanel";
import NewAppRegistrationForm from "@/components/customers/customer_app_registrations/NewCustomerAppRegistrationForm";
import { Application } from "@/api/applications";
import { AppRegistration } from "@/api/appRegistrations";
import { on } from "events";

interface Props {
  appReg?: AppRegistration;
  customer: Customer | undefined;
  applications: Application[];
  isPanelOpenned: boolean;
  onPanelClosed?: () => any;
  onSave?: (newAppReg: AppRegistration) => any;
  onUpdate?: () => any;
}

const NewCustomerAppRegistrationPanel = (props: Props) => {
  const [isPanelOpen, setIPanelOpen] = useState<boolean>(false);

  useEffect(() => {
    setIPanelOpen(props.isPanelOpenned);
  }, [props.isPanelOpenned]);

  const onClosePanel = () => {
    setIPanelOpen(false);
    if (props.onPanelClosed) props.onPanelClosed();
  };

  return (
    <>
      <RigthPanel
        header={`New app registration`}
        isOpen={isPanelOpen}
        dismissPanel={onClosePanel}
        childComponent={NewAppRegistrationForm}
        type={RigthPanelType.medium}
        childProps={{
          appReg: props.appReg,
          customer: props.customer,
          applications: props.applications,
          onClose: () => onClosePanel(),
          onSave: (newAppReg: AppRegistration) => {
            if (props.onSave) {
              props.onSave(newAppReg);
            }
            onClosePanel();
          },
          onUpdate: () => {
            if (props.onUpdate) {
              props.onUpdate();
            }
            onClosePanel();
          },
        }}
      ></RigthPanel>
    </>
  );
};

export default NewCustomerAppRegistrationPanel;
